const isAndroid = /(Android)/i.test(navigator.userAgent); 
const isIPhone = /(iPhone)/i.test(navigator.userAgent); 
const isIPad = /(iPad)/i.test(navigator.userAgent); 
const isKindle = /(Kindle)/i.test(navigator.userAgent); 
const isMobile = /(Mobile)/i.test(navigator.userAgent); 
const isPhone = isIPhone || isKindle || (isAndroid && isMobile);
const isTablet = isIPad || (isAndroid && !isMobile); //android tablets are not "mobile"
const isTouch = isPhone || isTablet;

class Context {
    
    constructor() {
        this.isInitial = true;
        this.isTouch = isTouch;
        this.isPhone = isPhone;
        this.isTablet = isTablet;

        this.mqSmall = window.matchMedia('only screen and (max-width: 719px)');
    }

    toggleInitial() {
        this.isInitial = false;
    }
}

export default (new Context);